export const ChevronDownIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5303 8.46991C18.8232 8.76281 18.8232 9.23768 18.5303 9.53057L12 16.0609L5.46967 9.53057C5.17678 9.23768 5.17678 8.76281 5.46967 8.46991C5.76256 8.17702 6.23744 8.17702 6.53033 8.46991L12 13.9396L17.4697 8.46991C17.7626 8.17702 18.2374 8.17702 18.5303 8.46991Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5303 8.46991C18.8232 8.76281 18.8232 9.23768 18.5303 9.53057L12 16.0609L5.46967 9.53057C5.17678 9.23768 5.17678 8.76281 5.46967 8.46991C5.76256 8.17702 6.23744 8.17702 6.53033 8.46991L12 13.9396L17.4697 8.46991C17.7626 8.17702 18.2374 8.17702 18.5303 8.46991Z"
        fill="currentColor"
        fill-opacity="0.2"
      />
    </svg>
  );
}

export const CouponFillIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21 16.2857C21 17.2325 20.2325 18 19.2857 18H4.71429C3.76751 18 3 17.2325 3 16.2857V7.71429C3 6.76751 3.76751 6 4.71429 6H19.2857C20.2325 6 21 6.76751 21 7.71429V9.40714C21 9.65567 20.7963 9.85223 20.5532 9.9038C19.5842 10.1093 18.8571 10.9698 18.8571 12C18.8571 13.0302 19.5842 13.8907 20.5532 14.0962C20.7963 14.1478 21 14.3443 21 14.5929V16.2857ZM11.5353 9.12813C11.4455 8.85174 11.0545 8.85174 10.9647 9.12813L10.4754 10.6339C10.4353 10.7575 10.3201 10.8412 10.1901 10.8412H8.60685C8.31623 10.8412 8.1954 11.2131 8.43051 11.3839L9.7114 12.3145C9.81655 12.3909 9.86055 12.5263 9.82038 12.6499L9.33113 14.1557C9.24132 14.4321 9.55767 14.6619 9.79278 14.4911L11.0737 13.5605C11.1788 13.4841 11.3212 13.4841 11.4263 13.5605L12.7072 14.4911C12.9423 14.6619 13.2587 14.4321 13.1689 14.1557L12.6796 12.6499C12.6395 12.5263 12.6835 12.3909 12.7886 12.3145L14.0695 11.3839C14.3046 11.2131 14.1838 10.8412 13.8932 10.8412H12.3099C12.1799 10.8412 12.0647 10.7575 12.0246 10.6339L11.5353 9.12813Z"
        fill="currentColor"
      />
    </svg>
  );
  
}


export const ChevronRightIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.92385 4.01988C7.18903 3.70167 7.66195 3.65868 7.98016 3.92385L17.6716 12L7.98016 20.0762C7.66195 20.3414 7.18903 20.2984 6.92385 19.9802C6.65868 19.662 6.70167 19.189 7.01988 18.9239L15.3285 12L7.01988 5.07618C6.70167 4.81101 6.65868 4.33809 6.92385 4.01988Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.92385 4.01988C7.18903 3.70167 7.66195 3.65868 7.98016 3.92385L17.6716 12L7.98016 20.0762C7.66195 20.3414 7.18903 20.2984 6.92385 19.9802C6.65868 19.662 6.70167 19.189 7.01988 18.9239L15.3285 12L7.01988 5.07618C6.70167 4.81101 6.65868 4.33809 6.92385 4.01988Z" fill="currentColor" fill-opacity="0.2"/>
</svg>

  );
}
